import React from 'react';
import { useSchool } from '@/context/SchoolContext';
import { useOverviewContext } from '@/context/OverviewContext';
import StackedContent from '@components/StackedContent/StackedContent';
import SubPageHero from '@/components/SubPageHero/SubPageHero';
import Accordion from '@components/Accordion/Accordion';
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb';
import config from '@/config';
import heroUnion from '@/assets/icons/bulb.png';
import ErrorContent from '@/components/ErrorContent/ErrorContent';
import StriderWriting from "@assets/images/strider-writing.svg";
import { WpErrorSection } from '@/components/ErrorFallbackSection/ErrorFallbackSection';

const SchoolStartFAQs = () => {
    const { data, loading } = useSchool();
    const { students, userRoleVal } = useOverviewContext();

    const faqs = data?.onboarding_content?.school_start_faqs ?? [];

    const schoolId = students?.[0]?.schoolId || '';
    const isPrivateSchool = config.app.privateSchoolIds.includes(schoolId);
    const userRole = userRoleVal?.toLowerCase();

    const filteredFaqs = faqs.filter((faq) => {

        // handle audience
        const audience = faq.audience?.toLowerCase?.();
        if (audience !== 'all' && audience !== userRole) {
        return false;
        }

        // handle school type
        const schoolType = faq.school_type?.toLowerCase?.();
        if (schoolType === 'private' && !isPrivateSchool) {
        return false;
        }
        if (schoolType === 'public' && isPrivateSchool) {
        return false;
        }

        return true;
    });

    const breadcrumbItems = [
        { title: "Home", path: "/" },
        { title: "School Information", path: "/schoolinfo" },
        { title: "School Start 101: Your Frequently Asked Questions Answered" }
    ];
    
    return (
        <>
        <div className="school-start-FAQs WP-Fallback">
            <div className="hero-section">
                <Breadcrumb items={breadcrumbItems} />
                <SubPageHero
                    theme="secondary"
                    title="School Start 101: Your Frequently Asked Questions Answered"
                    description="As we get closer to your start date, check back here for more specific information. You’ll also hear directly from your school with all the details you need to know."
                    image={heroUnion}
                />
            </div>
            <StackedContent>
                {loading ? (
                <StackedContent.Col1 cols="6">
                <div>
                    <h5 className="accordion-title placeholder-glow mb-2">
                        <span className="placeholder col-6 mb-5"></span>
                    </h5>
                    {[...Array(4)].map((_, idx) => (
                    <div key={idx}>
                        {/* Placeholder styled as accordion */}
                        <p className="accordion-items placeholder-glow mb-4">
                        <span className="placeholder col-10 d-block mb-2"></span>
                        <span className="placeholder col-7 d-block mb-1"></span>
                        <span className="placeholder col-4 d-block mb-1"></span>
                        </p>
                    </div>
                    ))}
                </div>
                </StackedContent.Col1>
                ) : faqs.length === 0 ? ( 
                    <StackedContent.Col1 cols="10">
                        <div className="error-page">
                            <WpErrorSection />
                        </div>
                    </StackedContent.Col1>
                ) : (
                 <StackedContent.Col2 cols="6">
                <Accordion defaultActiveKey="0">
                    {filteredFaqs.map((faq, index) => (
                    <Accordion.Item eventKey={index.toString()} key={index}>
                        <Accordion.Header>{faq.faq_title}</Accordion.Header>
                        <Accordion.Body>
                        <div dangerouslySetInnerHTML={{ __html: faq.faq_content }} />
                        </Accordion.Body>
                    </Accordion.Item>
                    ))}
                </Accordion>
                </StackedContent.Col2>
                )}
            
            </StackedContent>
        </div>
        </>
    );
};

export default SchoolStartFAQs;
